export interface ChoiceItemProps {
  index?: number;
  label: string;
  effect: string;
  selected?: boolean;
  onClick?: () => void;
  disabled?: boolean;
}

/** 原型基元：`.choice-item`（玩家行动 / 选项预览）。 */
export function ChoiceItem({ index, label, effect, selected, onClick, disabled }: ChoiceItemProps) {
  return (
    <button
      type="button"
      className="choice-item"
      data-selected={selected ? "true" : undefined}
      onClick={onClick}
      disabled={disabled}
      aria-pressed={selected}
    >
      <strong>{index === undefined ? label : `${index + 1}. ${label}`}</strong>
      <span>{effect}</span>
    </button>
  );
}
